var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPmn2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 476.61 169.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 476.61,
    height: 169.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M214.16,118.02c-51.15-4.85-105.24-29.56-136.83-71.01-10.68-14.07-18.68-30.13-23.13-47,.62,1.41,1.36,3.06,1.97,4.49,.99,2.1,2.44,5.27,3.52,7.34,1.9,3.78,4.06,7.73,6.28,11.34,31.54,52.42,90.31,81.32,148.19,94.86h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.65,118.02c57.88-13.53,116.66-42.44,148.19-94.86,2.22-3.61,4.38-7.56,6.28-11.34,1.05-2.03,2.55-5.26,3.52-7.34,.59-1.38,1.35-3.1,1.97-4.49-4.46,16.87-12.45,32.94-23.13,47-31.6,41.46-85.67,66.16-136.83,71.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.55,118.02c57.88-13.53,116.66-42.44,148.19-94.86,2.22-3.61,4.38-7.56,6.28-11.34,1.05-2.03,2.55-5.26,3.52-7.34,.59-1.38,1.35-3.1,1.97-4.49-4.46,16.87-12.45,32.94-23.13,47-31.6,41.46-85.67,66.16-136.83,71.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.97,118.02c-51.15-4.85-105.24-29.56-136.83-71.01C12.45,32.94,4.46,16.87,0,0,.62,1.41,1.36,3.06,1.97,4.49c.99,2.1,2.44,5.27,3.52,7.34,1.9,3.78,4.06,7.73,6.28,11.34,31.54,52.42,90.31,81.32,148.19,94.86h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.06,118.02c-51.15-4.85-105.24-29.56-136.83-71.01C39.55,32.94,31.55,16.87,27.1,0c.62,1.41,1.36,3.06,1.97,4.49,.99,2.1,2.44,5.27,3.52,7.34,1.9,3.78,4.06,7.73,6.28,11.34,31.54,52.42,90.31,81.32,148.19,94.86h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.46,118.02c57.88-13.53,116.66-42.44,148.19-94.86,2.22-3.61,4.38-7.56,6.28-11.34,1.05-2.03,2.55-5.26,3.52-7.34,.59-1.38,1.35-3.1,1.97-4.49-4.46,16.87-12.45,32.94-23.13,47C121.69,88.46,67.62,113.16,16.46,118.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.34,128.55c-7.02-.25-43.48,0-43.48,0v41.22h11.53v-13.03h31.95s11.53-1.5,12.65-11.65-5.64-16.29-12.65-16.54Zm1.62,13.94c-.12,3.18-2.93,5.61-6.12,5.61H28.52v-10.9l28.32-.13s5.26,0,5.14,5.26c0,.05,0,.1,0,.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.29 128.43 80.29 169.9 91.94 169.9 91.94 143.84 108.48 166.14 118.5 166.14 135.04 143.71 135.04 169.9 146.44 169.9 146.44 128.3 134.54 128.3 113.74 157.62 92.57 128.43 80.29 128.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.09 128.55 155.09 169.77 166.74 169.77 166.74 140.96 201.19 169.9 213.6 169.9 213.6 128.43 201.82 128.43 201.82 157.62 166.99 128.43 155.09 128.55"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPmn2);
export default __webpack_public_path__ + "static/media/PMN_2.7077e60cf95d42df9c7036e743f47912.svg";
export { ForwardRef as ReactComponent };